import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from '@/lib/auth/components/auth-provider'
import Unauthorized from '@/lib/auth/components/unauthorized'
import { PERMISSIONS, ROLES } from '@/lib/auth/roles'
import { getGuideYear } from '@/lib/filters/date/date-utils'
import { isCurrentPage, validateSearchWithDefaults } from '@/lib/utils'
import TopRatedStatusCompareFirms from '@/modules/top-rated/compare-firms'
import {
  topRatedStatusCompareFirmsQueryOptions
} from '@/modules/top-rated/compare-firms/hooks'
import {
  mergedTopRatedStatusCompareFirmsSchema,
  TopRatedStatusCompareFirmsSearch
} from '@/types/route-search-schemas'
import { DataLoader } from '@/types/router-context'
import {
  TOP_RATED_STATUS_COMPARE_FIRMS_PATH,
  TOP_RATED_STATUS_COMPARE_FIRMS_URL,
} from '@/utils/urls'

export const Route = createFileRoute(TOP_RATED_STATUS_COMPARE_FIRMS_PATH)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): TopRatedStatusCompareFirmsSearch => validateSearchWithDefaults(mergedTopRatedStatusCompareFirmsSchema, search),
  loader: ({ context: { queryClient, roles, permissions } }: DataLoader) => {
    if (isCurrentPage(TOP_RATED_STATUS_COMPARE_FIRMS_URL)) {
      return
    }

    if (roles.includes(ROLES.ROLE_ELEVATION) && permissions.includes(PERMISSIONS.IS_NETWORK_VIEW_ON_NETWORK)) {
      queryClient.prefetchQuery(topRatedStatusCompareFirmsQueryOptions())
    }
  },
  beforeLoad: () => {
    const guideYear = getGuideYear()

    return {
      breadcrumbs: [
        {label: 'Top Rated Tracker', path: '#'},
        {label: `Top Rated Firm ${guideYear} - Compare firms`, path: TOP_RATED_STATUS_COMPARE_FIRMS_URL},
      ],
      children: <div className={'h-10'}></div>
    }
  }
})

function RouteComponent() {
  return (
    <Authorisation roles={[ROLES.ROLE_ELEVATION]} permissions={[PERMISSIONS.IS_NETWORK_VIEW_ON_NETWORK]} forbiddenFallback={<Unauthorized/>}>
      <TopRatedStatusCompareFirms />
    </Authorisation>
  )
}
